export default __webpack_public_path__ + "static/media/978.acd1b59e.png";